// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YKOt","label":"styles_label__1LPHi"};